var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportesBlancov3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250 250",
    style: {
      enableBackground: "new 0 0 250 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17,24.9h151.3v73c0,1,0,1.9,0,2.8c0,0.3-0.1,0.5-0.3,0.7c-0.2,0.1-0.5-0.1-0.7-0.2c-1.7-0.9-3.3-1.9-5.1-2.7 c-0.8-0.3-1.3-1-1.2-1.8c0-21.1,0-42,0-63.1v-1.5H24.2v172.2c0.5,0,0.9,0.1,1.3,0.1c44.6,0,89.3,0,133.9,0c1.2,0,1.6-0.3,1.6-1.5 c-0.1-5.6,0-11.4-0.1-17c-0.1-0.6,0.2-1.2,0.8-1.4c1.9-0.9,3.7-1.9,5.6-2.9c0.2-0.1,0.4-0.1,0.6-0.1c0,0.4,0.1,0.7,0.1,1.1 c0,9.2,0,18.4,0,27.6c0,0.8-0.3,1.1-1.1,1.1c-0.4,0-0.6,0-1,0H17.1L17,24.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179,166c2.9,2.9,5.7,5.7,8.6,8.5c0.4,0.2,0.8,0.2,1.1,0c5-2.3,8.7-1.6,12.6,2.3l28.6,28.6 c1.9,1.9,3.2,4.1,3,6.9c-0.2,1.6-0.6,3.1-1.4,4.5c-2,3.6-4.5,6.9-8.8,8c-3.3,0.9-6.6,0.4-9.1-2c-9.6-9.6-19.1-19.3-28.6-29 c-1.8-1.7-3.1-3.7-3.8-6.1c-0.4-2.2-0.2-4.5,0.9-6.5c0.4-0.6,0.3-1.4-0.3-1.9c-2.6-2.6-5.2-5.5-7.8-8.2c-10,7.8-21.1,10.8-33.4,8 c-9.1-1.9-17.1-7.2-22.4-14.8c-12.4-17.2-8.6-41.2,8.6-53.6s41.2-8.6,53.6,8.6C190.6,133.3,190.1,152.5,179,166L179,166z  M148.7,172.5c17.2,0,31.2-13.9,31.2-31.2s-13.9-31.2-31.2-31.2c-17.2,0-31.2,13.9-31.2,31.1C117.5,158.4,131.5,172.4,148.7,172.5 L148.7,172.5z M220.2,218.4c0.8-0.3,1.5-0.6,2.2-1.1c1.1-1.1,2-2.2,2.8-3.4c1.1-1.6,0.9-2.4-0.5-3.7l-20.6-20.6 c-2.7-2.7-5.5-5.5-8.1-8.2c-0.8-1-2.2-1.3-3.3-0.7c-1.1,0.5-2,1.1-2.9,1.9c-2.2,2.1-2.2,3.7-0.3,5.9c0.3,0.3,0.4,0.5,0.7,0.7 c9.3,9.3,18.5,18.7,27.8,28C218.7,217.6,219.4,218,220.2,218.4L220.2,218.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.4,109.2h59.1v6.5H44.4V109.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.4,136.5c0-2,0-4,0-5.8c0-0.3,0.4-0.6,0.7-0.8c0.3-0.2,0.4,0,0.7,0h57.7v6.6H44.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.4,156.7v-6.5h59.1v6.5H44.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.4,177.4v-6.5h59.1v6.5H44.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.4,52.7h7.1v37.1h-7.1V52.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.8,62.2h7v27.7h-7V62.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69,89.8h-7.1V64.9H69V89.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M134.7,71.1h7.1v18.7h-7.1V71.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.6,89.7V72.9h7.1v16.8H43.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.4,89.8h-7V76.5h7V89.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M134.3,138.9c0.3,0.3,0.5,0.5,0.8,0.7c2.4,2.4,4.8,4.8,7.2,7.2c0.7,0.8,1.1,0.7,1.9,0 c6.3-6.2,12.5-12.3,18.7-18.4c0.8-0.8,1.3-0.8,2,0c0.9,1,1.9,1.9,2.9,2.7c0.8,0.6,0.8,1.1,0,1.8c-7.2,7.1-14.5,14.4-21.6,21.6 c-0.8,0.8-1.6,1.6-2.4,2.4c-0.5,0.5-0.9,0.6-1.4,0c-4.1-4.2-8.4-8.5-12.6-12.6c-0.4-0.4-0.5-0.8,0-1.2c1.2-1.2,2.6-2.6,3.8-3.8 C133.8,139.2,134.1,139,134.3,138.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportesBlancov3);
export default __webpack_public_path__ + "static/media/reportes-blanco v3.fbe7ef3b6c30423e4484775421d63937.svg";
export { ForwardRef as ReactComponent };